import React, { useEffect, useState } from "react";
//@ts-ignore
import { useParams } from 'react-router-dom'
import store from "src/store";
import CiReviewsHeader from "src/components/ci-reviews-header";
import CiReviewsTable from "src/components/ci-reviews-table";
import Progress from "src/components/progress";
import RefreshIcon from "@material-ui/icons/Refresh"

export default function CiReviews() {
    let { id } = useParams();
    id = id.replace(/[^a-z0-9]/gi, '');

    const [loading, setLoading] = useState(true);
    const [reviewData, setReviewData] = useState(null);

    useEffect(() => {
        getCiReviewList();
        getParentReviewData();
    }, []);

    const getCiReviewList = async () => {
        setLoading(true);
        await store.fetchtCiReviews(id);
        await store.fetchOneReview(id);
        setLoading(false);
    };

    const getParentReviewData = async () => {
        let data = await store.fetchOneReview(id);
        setReviewData(data)
    }

    store.useRerenderIfChange(() => [store.ciReviews]);

    const getCiReviewError = () => {
        if (store.ciReviews === undefined || !Array.isArray(store.ciReviews)) {
            return 'Unable to fetch ci reviews';
        } else {
            return 'No ci review found';
        }
    }

    const refreshCiReviews = async () => {
        setLoading(true);
        await store.updateCiReviewList(id);
        setLoading(false);
    }

    return (
        <>
            <div css={`
                padding:35px;
                background:#F6F6FA;
                min-height:100vh;
            `}>
                <div>
                    <CiReviewsHeader review={reviewData} />
                </div>
                <hr css={`
                margin-top:15px;
                border: 1px solid #EAEAF2;
                `}
                />
                <div css={`
                    margin-bottom:100px;
                `}>
                    {
                        (!loading && store.ciReviews?.length) ?
                            <div title="Refresh" css="margin-top: 10px;display:inline-block;flex-grow:1">
                                <div
                                    css={`cursor:pointer;display:flex; align-items: center; flex-direction: row; width: max-content; position:relative; bottom: 5px`}
                                    title="Refresh"
                                    onClick={() => {
                                        refreshCiReviews();
                                    }}
                                >
                                    <RefreshIcon style={{ color: '#000' }} />
                                    <div css={`width: max-content`}>Refresh</div>
                                </div>
                            </div> : null
                    }
                    {loading && <Progress time={5000} />}

                    {!loading && <div>
                        {
                            store.ciReviews?.length ?
                                <CiReviewsTable />
                                : getCiReviewError()
                        }
                    </div>}
                </div >
            </div>
        </>
    )
}